// extracted by mini-css-extract-plugin
export default {"paginationBttns":"pagination_paginationBttns__XnQlh","active":"pagination_active__ZOqSs"};